import BoxFiles from './BoxFiles';

export default BoxFiles;